import React from "react";
import ServiceHome from "./ServiceHome";
import serviceone from "../Images/mentalillnessimage.jpg";
import servicetwo from "../Images/deaddictionimage.jpg";
import servicetree from "../Images/epilipsyimage.jpg";
import servicefour from "../Images/electrotherpyimage.jpg";
import servicefive from "../Images/sexual helth image 1.jpg";
import servicesix from "../Images/psycotherapyimage.png";
import serviceseven from "../Images/childimage.jpg";
import serviceeight from "../Images/geriatricimage.jpg"

const ServiceImages = () => {
  return (
    <>
      <div class="flex  flex-wrap justify-center gap-3 mx-auto p-1">
        <div className=" service  ">
          <ServiceHome
            images={serviceone}
            title={"Mental illness"}
            link={"/Mentalillness"}
            content={"Learn More"}
          />
        </div>
        <div className=" service  ">
          <ServiceHome
            images={servicetwo}
            title={"De-addiction"}
            link={"/Deaddiction"}
            content={"Learn More"}
          />
        </div>

        <div className=" service  ">
          <ServiceHome
            images={servicetree}
            title={"Epilepsy"}
            link={"/Epilipsy"}
            content={"Learn More"}
          />
        </div>

        <div className=" service  ">
          <ServiceHome
            images={servicefour}
            title={"Electro Convulsive Therapy"}
            link={"//Electrotherapy"}
            content={"Learn More"}
          />
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-3 mx-auto p-1">
        <div className=" service ">
          <ServiceHome
            images={servicefive}
            title={"Sexual Health"}
            link={"/SexualHelth"}
            content={"Learn More"}
          />
        </div>

        <div className=" service ">
          <ServiceHome
            images={servicesix}
            title={"Psychotherapy"}
            link={"/Psycotherapy"}
            content={"Learn More"}
          />
        </div>

        <div className=" service  ">
          <ServiceHome
            images={serviceseven}
            title={"Child Guidance Clinic"}
            link={"/Child"}
            content={"Learn More"}
          />
        </div>

        <div className=" service ">
          <ServiceHome
            images={serviceeight}
            title={"Dementia & Geriatric Care"}
            link={"/geriatric"}
            content={"Learn More"}
          />
        </div>
      </div>
    </>
  );
};

export default ServiceImages;
